import React, { ReactNode } from 'react'
import LaneArrowIcon from 'transfix-icons/build/LaneArrowIcon'
import { Box, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui'

interface ILaneProps {
  laneTo: string
  laneFrom: string
  children: ReactNode
}

export const LaneGroup = ({ children, laneFrom, laneTo }: ILaneProps) => (
  <div className='relative' role='table' aria-label='lane group'>
    <Box
      p={3}
      className='lane-sticky-header'
      display='flex'
      alignItems='center'
      borderTop={1}
      borderColor={brandColors.coolGray4}>
      <Typography variant='body1'>{laneFrom} </Typography>
      <LaneArrowIcon size='large' className='db mh2 ' />
      <Typography variant='body1'> {laneTo}</Typography>
    </Box>
    {children}
  </div>
)
